module.exports = __webpack_public_path__ + "img/icon-snacks.70780c5f.svg";